window.fisherAnalytics.fisherURLRules = {
    enabled: false,
    urlPatterns: ['/shop/orderdisplayview',
        '/shop/cart/{id}/update',
        '/shop/cart/{id}/remove/{sku}',
        '/shop/cart/{id}/empty',
        '/shop/ShoppingCart.html',
        '/shop/cart','store1/mylist',
        '/shop/CheckoutConfirmation'],
    // Common methods that can be reused
    methods: {
        processCACart: function() {
            console.log('Processing CA test - custom-url-rules.js');
        }
    },
    urlRules: {
        '/shop/orderdisplayview': {
            method: ['window.fisherAnalytics.cart.processLegacyCartPage','window.fisherAnalytics.cart.clearUpdateStorageLegacyCart'],
            description: 'This rule process legacy CA cart data'
        },
        '/shop/cart/{id}/update': {
            method: ['window.fisherAnalytics.cart.processLegacyCartPage'],
            description: 'This rule process legacy CA cart data.  Removed \'window.fisherAnalytics.cart.processUpdateLegacyCartEvents\' it will now fire from Launch'
        },
        '/shop/cart/{id}/remove/{sku}': {
            method: ['window.fisherAnalytics.cart.processLegacyCartPage'],
            description: 'This rule process legacy CA cart data'
        },
        '/shop/cart/{id}/empty': {
            method: ['window.fisherAnalytics.cart.processLegacyCartPage','window.fisherAnalytics.cart.deleteCartId','window.fisherAnalytics.cart.deleteFindingMethod','window.fisherAnalytics.cart.cartEmptyEvent'],
            description: 'This rule process legacy CA cart data'
        },
        '/shop/ShoppingCart.html': {
            method: ['window.fisherAnalytics.cart.processLegacyCartPage','window.fisherAnalytics.cart.clearUpdateStorageLegacyCart'],
            description: 'This rule process legacy CA cart data'
        },
        '/shop/cart': {
            method: 'window.fisherAnalytics.cart.processLegacyCartPage',
            description: 'This rule process legacy CA cart data'
        },
        'store1/mylist': {
            method: window.fisherAnalytics.myList.setPageTabName,
            description: 'This rule detects the My List page and sets the tab name',
            pauseExecution: 3500 // Pause execution to allow dynamic React components to load
        },
        '/shop/CheckoutConfirmation': {
            method: ['window.fisherAnalytics.cart.deleteCartId', 'window.fisherAnalytics.cart.deleteFindingMethod', 'window.fisherAnalytics.cart.clearUpdateStorageLegacyCart'],
            description: 'This rule process checkout confirmation page'
        }
    },
    process: function() {
        var href = document.location.href;
        var self = this;

        this.urlPatterns.forEach(function(pattern) {
            // Create a proper regex from the pattern
            var regexPattern = pattern
                .replace(/\//g, '\\/') // Escape forward slashes
                .replace(/{id}/g, '([^/]+)') // Match any characters except / for {id}
                .replace(/{sku}/g, '([^/]+)'); // Match any characters except / for {sku}

            // Make it match anywhere in the URL
            var regex = new RegExp(regexPattern.replace(/^\\\//, ''));

            // Test if the URL contains the pattern
            if (regex.test(href) && self.urlRules[pattern]) {
                // Get the method name or function
                var methodRef = self.urlRules[pattern].method;
                var pauseExecution = self.urlRules[pattern].pauseExecution || false;

                // If methodRef is an array, process each method
                if (Array.isArray(methodRef)) {
                    methodRef.forEach(function(singleMethod) {
                        if (typeof singleMethod === 'string' && self.methods[singleMethod]) {
                            if(pauseExecution){
                                setTimeout(function() {
                                    self.methods[singleMethod]();
                                }, pauseExecution);
                            } else {
                                self.methods[singleMethod]();
                            }
                        } else if (typeof singleMethod === 'function') {
                            if(pauseExecution){
                                setTimeout(function() {
                                    singleMethod();
                                }, pauseExecution);
                            } else {
                                singleMethod();
                            }
                        } else if (typeof singleMethod === 'string') {
                            var parts = singleMethod.split('.');
                            var func = window;
                            for (var i = 0; i < parts.length; i++) {
                                func = func[parts[i]];
                                if (!func) break;
                            }
                            if (typeof func === 'function') {
                                if(pauseExecution){
                                    setTimeout(function() {
                                        func();
                                    }, pauseExecution);
                                } else {
                                    func();
                                }
                            }
                        }
                    });
                } else {
                    // Original logic for single method
                    if (typeof methodRef === 'string' && self.methods[methodRef]) {
                        if(pauseExecution){
                            setTimeout(function() {
                                self.methods[methodRef]();
                            }, pauseExecution);
                            return;
                        } else {
                            self.methods[methodRef]();
                        }
                    } else if (typeof methodRef === 'function') {
                        if(pauseExecution){
                            setTimeout(function() {
                                methodRef();
                            }, pauseExecution);
                            return;
                        } else {
                            methodRef();
                        }
                    } else if (typeof methodRef === 'string') {
                        var parts = methodRef.split('.');
                        var func = window;
                        for (var i = 0; i < parts.length; i++) {
                            func = func[parts[i]];
                            if (!func) break;
                        }
                        if (typeof func === 'function') {
                            if(pauseExecution){
                                setTimeout(function() {
                                    func();
                                }, pauseExecution);
                                return;
                            } else {
                                func();
                            }
                        }
                    }
                }
            }
        });
    },
    init: function() {
            try{
                this.process();
            } catch (e) {
                console.error('Error in fisherURLRules init:', e);
            }
    }
};

window.fisherAnalytics.fisherURLRules.init();